

let highlightMap = new Map();


function highlight(val) {
  /** @type {HTMLElement} */
  let node = document.querySelector(val);

  let boundingRect = node.getBoundingClientRect();
  
  let highlightmask = document.createElement("div");
  highlightmask.style.position = "absolute";
  highlightmask.style.borderRadius = "5px";
  
  
  highlightmask.className = "highlightmask";

  if (highlightMap.has(val)) {
    highlightMap.get(val).remove();
    highlightMap.delete(val);
  }
  highlightMap.set(val, highlightmask);
  let padding = 10;
  
  let x = boundingRect.left - (padding / 2);
  let y = boundingRect.top - (padding / 2);
  let width = (boundingRect.right - boundingRect.left) + padding;
  let height = (boundingRect.bottom - boundingRect.top) + padding;
  let right = boundingRect.right + (padding / 2);
  let bottom = boundingRect.bottom + (padding / 2);
  
  highlightmask.style.width = width + "px";
  highlightmask.style.height = height + "px";

  highlightmask.style.left = x + "px";
  highlightmask.style.top = y + "px";
  if (!highlight.parentElement) {
    document.body.appendChild(highlightmask);
  }
}

function unhighlight(val) {
    /** @type {HTMLElement} */
  let blink = highlightMap.get(val);
  if (blink) {
    blink.remove();
    highlightMap.delete(val);
  }
}




export {
  highlight,
  unhighlight
}